import { ArrowBack } from "mosaic-react-icons";
const navigation = (label, toRoute) => [
    {
        priority: 999,
        name: `label(${label})`,
        to: `${toRoute}`,
        exact: true,
        icon: ArrowBack,
    },
];

export default navigation;
